import { ApiCallError } from 'app/http/ApiCallError';

const CONCURRENT_JOBS_LIMIT_CODE = 10;

export type ClaimJobErrorModal = { title?: string; message: string };

const readClaimFailure = (body: unknown): ClaimJobErrorModal | null => {
  if (typeof body !== 'object' || body === null) {
    return null;
  }
  if ('code' in body && body.code === CONCURRENT_JOBS_LIMIT_CODE) {
    return {
      title: 'You’ve reached your job limit',
      message: 'To continue you need to finish jobs you already claimed.',
    };
  }
  if ('message' in body && typeof body.message === 'string' && body.message) {
    return { message: body.message };
  }
  return null;
};

export const getClaimJobError = (input: unknown): ClaimJobErrorModal | null => {
  if (input instanceof ApiCallError) {
    return input.status === 409 ? readClaimFailure(input.body) ?? { message: input.message } : null;
  }
  if (typeof input === 'object' && input !== null && 'success' in input && input.success === false) {
    return readClaimFailure(input) ?? { message: 'Something went wrong' };
  }
  return null;
};
